module.exports = {
  email: 'zhibinren79@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/zbr79',
    },
  ],

  navLinks: [
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Education',
      url: '/#education',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#1d1d1f',
    navy: '#ffffff',
    darkNavy: '#ffffff',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '24px',
    duration: 700,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
